class Tab {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
		if($(".js-madori-thum").length > 0){
			$('.js-madori-thum li').on('click', function () {

				const imgSrc = $(this).find('img').attr('src');
		
				// メイン画像変更
				$('.js-madori-main img').attr('src', imgSrc);
		
				// active切替
				$('.js-madori-thum li').removeClass('is-active');
				$(this).addClass('is-active');
		
			});
		}

		// if($(".js-tab-content").length > 0){
		// 	$(".js-tab-content").each(function(){

		// 		const $wrap = $(this);
		// 		const $tabs = $wrap.prev().find(".js-tab-item");
		// 		const $contents = $wrap.children("div");
			
		// 		$tabs.removeClass("is-active").first().addClass("is-active");
		// 		$contents.hide().first().show();
			
		// 		$tabs.on("click", function(){			
		// 			const index = $(this).index();			
		// 			$tabs.removeClass("is-active");
		// 			$(this).addClass("is-active");
			
		// 			$contents.hide().eq(index).show();
			
		// 		});
			
		// 	});
		// }

		if($(".js-tab").length > 0){
			$(".js-tab").each(function(){

				const $wrap = $(this);
				const $tabs = $wrap.find(".js-tab-item");
				const $contents = $wrap.find(".js-tab-content");
			
				$tabs.removeClass("is-active").first().addClass("is-active");
				$contents.hide().first().show();
			
				$tabs.on("click", function(){

					const index = $tabs.index(this);
				
					$tabs.removeClass("is-active");
					$(this).addClass("is-active");
				
					$wrap.find(".js-tab-content").hide();
					$wrap.find(".js-tab-content").eq(index).show();
				
				});
			
			});
		}
	}
}
